import React from 'react';
import { translate } from 'react-i18next';

import {Button, Form, Input, Grid, Header, Message, Label, Segment, Modal, Checkbox} from 'semantic-ui-react';
import {colors, fontSizes, fonts, shadow} from 'style';

var style = {
    buttonWrapper: {
        textAlign: 'center',
    },
    contentDiv: {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        float:'right',
    },
    button: {
        fontWeight: 'normal',
        ...fonts.body,
        lineHeight: '1.5',
        borderRadius: '100px',
        backgroundColor: colors.themeBlue,
        color: '#fff',
        width: '300px',
        boxShadow: shadow,
    },
}

const EditFrequency = ({t, 
                        pattern, 
                        onSubmit, 
                        onClose, 
                        updatePattern}) => (
        <Modal closeIcon open size="mini" onClose={onClose}>
        <Modal.Header>{t('Frequency')}</Modal.Header>
        <Modal.Content>
            <Form onSubmit={()=>onSubmit(pattern)}>

                    <div className="bold clearfix">
                        {t('Daily')}
                        <div style={style.contentDiv}><Checkbox checked={pattern===127} onChange={()=>updatePattern(127)} /></div>
                    </div>

                    <div className="bold clearfix">
                        {t('Weekends')}
                        <div style={style.contentDiv}><Checkbox checked={pattern===65} onChange={()=>updatePattern(65)} /></div>
                    </div>

                    <div className="bold clearfix">
                        {t('Weekdays')}
                        <div style={style.contentDiv}><Checkbox checked={pattern===62} onChange={()=>updatePattern(62)}/></div>
                    </div>

                    <Header>{t('Or Weekly')}</Header>

                    <div className="bold clearfix">
                        {t('Monday')}
                        <div style={style.contentDiv}><Checkbox checked={(pattern&0x2)!==0} onChange={()=>updatePattern(pattern^0x2)} /></div>
                    </div>

                    <div className="bold clearfix">
                        {t('Tuesday')}
                        <div style={style.contentDiv}><Checkbox checked={(pattern&0x4)!==0} onChange={()=>updatePattern(pattern^0x4)} /></div>
                    </div>

                    <div className="bold clearfix">
                        {t('Wednesday')}
                        <div style={style.contentDiv}><Checkbox checked={(pattern&0x8)!==0} onChange={()=>updatePattern(pattern^0x8)} /></div>
                    </div>

                    <div className="bold clearfix">
                        {t('Thursday')}
                        <div style={style.contentDiv}><Checkbox checked={(pattern&0x10)!==0} onChange={()=>updatePattern(pattern^0x10)} /></div>
                    </div>

                    <div className="bold clearfix">
                        {t('Friday')}
                        <div style={style.contentDiv}><Checkbox checked={(pattern&0x20)!==0} onChange={()=>updatePattern(pattern^0x20)} /></div>
                    </div>

                    <div className="bold clearfix">
                        {t('Saturday')}
                        <div style={style.contentDiv}><Checkbox checked={(pattern&0x40)!==0} onChange={()=>updatePattern(pattern^0x40)} /></div>
                    </div>

                    <div className="bold clearfix">
                        {t('Sunday')}
                        <div style={style.contentDiv}><Checkbox checked={(pattern&0x1)!==0} onChange={()=>updatePattern(pattern^0x1)} /></div>
                    </div>

                   
                    <br />
                    <br />
                    <div style={style.buttonWrapper}>
                        <Button style={style.button} type='submit'>{t('Save')}</Button>    
                    </div>
            </Form>
        </Modal.Content>
      </Modal>
  );

export default translate('categories')(EditFrequency);



// WEBPACK FOOTER //
// ./src/modules/categories/EditFrequency.js